import GetTPCommandPanel from './defaultCommandPanel';
import TPActions from './actions';

export default GetTPCommandPanel;

export { TPActions };
